import { forwardRef, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import styles from './Image.module.scss'

const Image = forwardRef(function ({ src, alt, className, ...props }, ref) {
  const [isInView, setIsInView] = useState(false)
  const imageRef = useRef()

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true)
            observer.disconnect()
          }
        })
      },
      {
        threshold: 0.1, // load when 10% of the image is in view
      }
    )

    if (imageRef.current) {
      observer.observe(imageRef.current)
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (ref) {
      ref.current = imageRef.current
    }
  }, [ref])

  return (
    <img
      ref={imageRef}
      src={isInView ? src : ''}
      alt={alt}
      className={classNames(styles.image, className)}
      style={{ opacity: isInView ? 1 : 0, transition: 'opacity 0.3s ease-in' }}
      {...props}
    />
  )
})

export default Image
